module.exports = __webpack_public_path__ + "static/media/176.df29e11b.svg";